<template>
  <div class="header-wapper">
    <div class="button-wapper">
      <span>请核实信息，如无误请点击</span>
      <el-button style="margin: 0 12px;" size="small" type="primary" @click="submit">提交</el-button>
      <p>如需修改请点击 <span class="point" @click="goEdit">返回编辑</span> </p>
    </div>
    <div class="text-wapper">{{ text }}</div>
  </div>
</template>

<script >
export default {
props:{
  params:{
    type:Object,
    default:{}
  },
  text:''
},
methods:{
  goEdit(){
    // path有值 为路由跳转 path为空显示弹框
    if(this.params.path){
      this.$router.push({
        path:this.params.path,
        query:this.params.query
      })
    } else {
      this.$emit('isShow')
    }
  },
  submit(){
    this.$emit('submit')
  }
}
}
</script>

<style scoped>
.point{
  cursor: pointer;
  color: #409eff;
}
.header-wapper{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.button-wapper{
  display: flex;
  align-items: center;
}
.text-wapper{
  color: red;
  font-size: 14px;
}
</style>